export default function maskString(str) {
  if (!str) return '';

  // 验证邮箱格式（简单校验）
  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str);

  if (isEmail) {
    // 邮箱处理逻辑
    const [username, domain] = str.split('@');
    const domainParts = domain.split('.');
    const tld = domainParts.pop(); // 顶级域名（如 com、cn）
    const mainDomain = domainParts.join('.'); // 主域名（如 qq、163）

    // 用户名：保留前4位，其余用****替换（若长度≤4则不替换）
    const maskedUsername = username.length > 4 ? username.slice(0, 4) + '****' : username;

    // 域名：主域名替换为****，保留顶级后缀
    const maskedDomain = `****.${tld}`;

    return `${maskedUsername}@${maskedDomain}`;
  } else {
    // 非邮箱处理：中间4位替换为****
    const len = str.length;
    if (len <= 4) {
      // 长度≤4位：全部替换为****（不足4位补*）
      return '****'.slice(0, len);
    } else {
      // 长度>4位：取前半部分 + **** + 后半部分
      const half = Math.floor((len - 4) / 2);
      return str.slice(0, half) + '****' + str.slice(half + 4);
    }
  }
}
